import styled from 'styled-components';

export const Image = styled.img`
  width: ${(props) => (props.height ? 'auto' : props.width || '100%')};
  height: ${(props) => props.height || 'auto'};
  margin: ${(props) => props.margin || '0'};
`;

export const GuideButtonImage = styled.img`
  height: 21px;
  vertical-align: text-bottom;
  padding-top: 2px;
`